import React, { FC, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import { ReleaseOfflineLicense } from './ReleaseOfflineLicense';
import { LicenseReleased } from './LicenseReleased';
import { ReleaseOnlineLicense } from './ReleaseOnlineLicense';
import { LicenseContext } from '../../contexts/LicenseContext';
import { ReleaseErrorLicense } from './ReleaseErrorLicense';
import { ELicenseMode } from '../../models/ILicense';
import { ReleaseOfflineDirectorLicense } from './ReleaseOfflineDirectorLicense';

interface IProps {
  open: boolean;
  onClose: () => void;
}

export const ReleaseLicenseStepsDialog: FC<IProps> = ({ open, onClose }) => {
  const license = useContext(LicenseContext)!;

  const licenseMode = license.mode;

  return (
    <Dialog open={open} onClose={onClose}>
      {licenseMode === ELicenseMode.Airgap ? <ReleaseOfflineLicense onClose={onClose} /> : null}
      {licenseMode === ELicenseMode.Offline ? <ReleaseOfflineDirectorLicense onClose={onClose} /> : null}
      {licenseMode === ELicenseMode.Error ? <ReleaseErrorLicense onClose={onClose} /> : null}
      {licenseMode === ELicenseMode.Online ? <ReleaseOnlineLicense onClose={onClose} /> : null}
      {licenseMode === ELicenseMode.Unused ? <LicenseReleased onClose={onClose} /> : null}
    </Dialog>
  );
};
